const items = document.querySelectorAll(".numbered-list-paras .item")

if (items.length > 0) {
    items.forEach((item, i) => {
        item.style.top = `-${i}px`;
    })
}